const configuredApiBaseUrl = ((import.meta as ImportMeta & {
  env?: { VITE_AI_API_URL?: string };
}).env?.VITE_AI_API_URL ?? '').replace(/\/+$/, '');

export const apiBaseUrl = configuredApiBaseUrl;

export function buildApiUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${apiBaseUrl}${normalizedPath}`;
}
